export const HELP_URL = 'https://verantos.freshdesk.com/support/home';
export const PROFILE_PATH = 'profile';
